import { render, staticRenderFns } from "./altaPostal.vue?vue&type=template&id=80a29dc6&scoped=true"
import script from "./altaPostal.vue?vue&type=script&lang=js"
export * from "./altaPostal.vue?vue&type=script&lang=js"
import style0 from "./altaPostal.vue?vue&type=style&index=0&id=80a29dc6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80a29dc6",
  null
  
)

export default component.exports